import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import AdvancedRecordTable from '../../../Tables/advancedRecord/AdvancedRecordTable';
import { useDteInvalidationLogs } from '../../../../hooks/hacienda/useDteInvalidationLogs';
import { dteInvalidationLogColumns } from '../../../../features/hacienda/invalidationLog/dteInvalidationLogColumns';
import { getDteInvalidationLogActions } from '../../../../features/hacienda/invalidationLog/dteInvalidationLogActions';
import { getDteInvalidationLogFilters } from '../../../../features/hacienda/invalidationLog/dteInvalidationLogFilters';
import DteInvalidationDetailModal from './DteInvalidationDetailModal';

const DteInvalidationLogHistory: React.FC = () => {
  const {
    paginatedList,
    paginator,
    pageSize,
    updatePageSize,
    handlerGetSearch,
    handlerGetById,
    handlerDownloadRequestJson,
    handlerDownloadResponseJson,
    selectedLog,
    showDetailModal,
    closeDetailModal,
  } = useDteInvalidationLogs();

  const { page } = useParams();
  const currentPage = page ? parseInt(page, 10) : 0;

  // 🔎 Estado filtros
  const [filters, setFilters] = useState<any>({});
  const [filtersApplied, setFiltersApplied] = useState(false);

  // 🔹 Aplicar filtros
  const handleFilterChange = (newFilters: any) => {
    setFilters(newFilters);
    setFiltersApplied(true);
    handlerGetSearch(newFilters, 0, pageSize);
  };

  // 🔹 Cambio de página
  const handlePageChange = (page: number) => {
    handlerGetSearch(filtersApplied ? filters : {}, page, pageSize);
  };

  // 🔹 Cambio tamaño página
  const handlePageSizeChange = (size: number) => {
    updatePageSize(size);
    handlerGetSearch(filtersApplied ? filters : {}, 0, size);
  };

  // 🔹 Carga inicial
  useEffect(() => {
    handlerGetSearch({}, currentPage, pageSize);
  }, []);

  const getActions = (row: any) =>
    getDteInvalidationLogActions({
      row,
      handlers: {
        onViewDetail: handlerGetById,
      },
    });

  const filterFields = getDteInvalidationLogFilters();

  return (
    <>
      <AdvancedRecordTable
        columns={dteInvalidationLogColumns}
        data={paginatedList}
        paginator={paginator}
        pageSize={pageSize}
        filtersConfig={filterFields}
        onFilterChange={handleFilterChange}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        getActions={getActions}
        url="/dte-invalidation-logs"
        noDataMessage="No hay registros de anulación disponibles."
      />

      <DteInvalidationDetailModal
        isOpen={showDetailModal}
        log={selectedLog}
        onClose={closeDetailModal}
        onDownloadRequest={handlerDownloadRequestJson}
        onDownloadResponse={handlerDownloadResponseJson}
      />
    </>
  );
};

export default DteInvalidationLogHistory;
